export default __webpack_public_path__ + "static/media/github_logo.15e591a7.png";